import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/lottery-prediction-page.tsx");
